import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { TextField, Typography } from '@mui/material';
import Stack from '@mui/material/Stack';
import { useSnackbar } from '../../../context/SnackbarContext';
import { useTranslation } from 'react-i18next';
import { updatePassword } from '../../../api/profileService';
import { useAuth } from '../../../hooks/useAuth';

export default function ChangePasswordForm({ successCallback = null, open, onClose }) {

    const { t } = useTranslation('common'); 

    const { isAuthenticated, role, handleLogout } = useAuth();

    const [oldPassword, setOldPassword] = React.useState("");
    const [newPassword, setNewPassword] = React.useState("");

    const { showSnackbar } = useSnackbar();

    const onUpdateSuccess = () => {
      handleLogout();
    };

    React.useEffect(() => {
      // reset field when there are changes (e.g. when opening edit)
      setOldPassword("");
      setNewPassword("");
    }, [open]);

    const handleSave = async () => {
      if (!oldPassword.trim()) {
        showSnackbar(t('profile.messages.current_password_required'), "warning");
        return;
      }
      if (!newPassword.trim()) {
        showSnackbar(t('profile.messages.new_password_required'), "warning");
        return;
      }
      if (newPassword.trim().length < 6) {
        showSnackbar(t('profile.messages.password_length'), "warning");
        return;
      }
      if (newPassword.trim() === oldPassword.trim()) {
        showSnackbar(t('profile.messages.passwords_same'), "warning");
        return;
      }
      try 
      {
        await updatePassword({ 
            oldPassword: oldPassword,
            password: newPassword
        });
        onUpdateSuccess();
        showSnackbar(t('profile.messages.update_password_success'), "success");
        setOldPassword("");
        setNewPassword("");
        onClose();     // close dialog
      } catch (err) {
        console.log("err", err);
        showSnackbar(err.response.data.error, "error");
      }

    };

    const handleCancel = () => {
        setOldPassword("");
        setOldPassword("");
      onClose();
    };

    return (
        <>
        <Dialog onClose={handleCancel} open={open} disableRestoreFocus>

        <DialogTitle>Change Password</DialogTitle>

        <DialogContent dividers>
            <Stack spacing={1}>
              <Typography variant="body2" sx={{ mt: 0 }}>You will be automatically logged off after a successful password change.</Typography>
              <TextField
                  label="Current Password"
                  variant="outlined"
                  value={oldPassword}
                  type="password"
                  onChange={(e) => setOldPassword(e.target.value)}
                  fullWidth
              />
              <TextField
                  label="New Password"
                  variant="outlined"
                  value={newPassword}
                  type="password"
                  onChange={(e) => setNewPassword(e.target.value)}
                  fullWidth
              />
            </Stack>
        </DialogContent>

        <DialogActions>
            <Button onClick={handleSave}>
              Submit
            </Button>
            <Button onClick={handleCancel}>Cancel</Button>
        </DialogActions>
        </Dialog>
        </>
    );
}